"use client";

import { useTranslation } from "react-i18next";

import i18n from "@/shared/config/i18n/client";
import {
  LANGUAGE_STORAGE_KEY,
  resolveLanguage,
  SUPPORTED_LANGUAGES,
  type AppLanguage,
} from "@/shared/config/i18n/config";
import { loadLanguageBundle } from "@/shared/config/i18n/resources";

export function useLanguage() {
  const { i18n: translationInstance } = useTranslation();
  const language = resolveLanguage(translationInstance.resolvedLanguage ?? translationInstance.language) as AppLanguage;

  const setLanguage = async (value: string) => {
    const nextLanguage = resolveLanguage(value);
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
    document.documentElement.lang = nextLanguage;

    const bundle = await loadLanguageBundle(nextLanguage);
    if (bundle) {
      i18n.addResourceBundle(nextLanguage, "translation", bundle.translation, true, true);
    }
    await i18n.changeLanguage(nextLanguage);
  };

  return {
    language,
    languages: SUPPORTED_LANGUAGES,
    setLanguage,
  };
}
